import Api2Talk from '../api2talk';

// Item #2 roadmap chatbot JOINT (07/10/2026) — CRUD mínimo de tags do hirer.
// Backend: Mexx.Mexx2Talk.Api/Controllers/TagController.cs
// - GET  /api/tags   → lista tags cadastradas do hirer (id+name), ordem alfabética.
// - POST /api/tags   → find-or-create de tag no cadastro (sem vincular a chat).
//                      Usado pelo TagInspector quando admin digita nome novo + Enter.
const PATH = '/tags';

const getAll = async () => {
  try {
    const response = await Api2Talk.get(PATH);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const create = async (name) => {
  try {
    const response = await Api2Talk.post(PATH, { name });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export { getAll, create };
